import React from 'react'

import Layout from '../layouts/en'
import SEO from '../components/seo'
import Bubble from '../components/Bubble'
import IntroBox from '../components/IntroBox'
import IllustrationBox from '../components/IllustrationBox'
import Testimonial from '../components/Testimonial'

import FlickitySlider from '../components/FlickitySlider'
import AnnualReviewSlider from '../components/AnnualReviewSlider'
import FinancialReportAndPersonnelStructure from '../components/FinancialReportAndPersonnelStructure'
import MoreText from '../components/MoreText'
import VideoButton from '../components/VideoButton'

//  Data
const TeamMembers = require('../data/TeamMembers')
const Awards = require('../data/Awards')
const Schools = require('../data/Schools')
const CollegeAchievements = require('../data/CollegeAchievements')
const StudentActivities = require('../data/StudentActivities')
const StudentStories = require('../data/StudentStories')

const IndexPage = (props) => (
  <Layout location={props.location}>
    <SEO title="League of Elite" />

    <div
      className="bg-center bg-cover py-12 md:bg-center-x-61p lg:bg-center"
      style={{ backgroundImage: `url(/AnnualReport2017-2018/images/bg-elite-teacher.jpg)` }}
    >
      <div className="container" data-aos="fade-up" data-aos-delay={400} data-aos-duration={1200} id="embrace-the-present-and-face-future-challenges">
        <Bubble className="w-full md:w-1/2"
          title="League of Elite"
          subtitle="Embrace the Present and Face Future Challenges"
        >
          <div className="text-sm md:text-base leading-relaxed text-justify">
            <p className="mb-4">Institute for Tourism Studies (IFT), established in 1995, is a public institution of higher education under the governance of the Secretary for Social Affairs and Culture of the Macao Special Administrative Region Government, offering a wide range of tourism related undergraduate programmes and professional training, which include areas in hospitality, tourism business, heritage, events, retail and marketing, leisure and entertainment, sports and recreation, creative and cultural studies, and culinary arts.</p>
            <p>Tourism College and Tourism and Hotel School are the 2 major components of IFT. They offer four-year bachelor’s degree programmes and professional training courses respectively.</p>
          </div>
        </Bubble>
      </div>
    </div>

    <div className="bg-gray-200 py-8 md:py-12">
      <div className="container">
        <div className="flex flex-row flex-wrap -mx-2">
          {
            Schools.map((school, i) => (
              <div key={i} className="w-full md:w-1/2 flex" data-aos={`${i == 0 ? 'fade-right' : 'fade-left'}`} data-aos-delay={850}>
                <IntroBox className="mx-2 text-sm md:text-base h-full"
                  title={school.title['en']}
                  more
                  link={`/${school.link['en']}`}
                  image={school.image}
                >
                  {school.description['en']}
                </IntroBox>
              </div>
            ))
          }
        </div>
      </div>
    </div>

    <div className="container py-8 md:py-12">
      {/*<h2 className="text-3xl md:text-5xl text-yellow-500 text-center mb-8 md:mb-12">College achievement</h2>*/}

      <div className="flex flex-row flex-wrap -mx-8 md:mb-12" id="highlights">
        {
          CollegeAchievements.illustrationItems.map((item, i) => (
            <div key={i} className="w-1/2 md:w-1/4 mb-12" data-aos="fade-up" data-aos-delay={i * 150}>
              <div className="mx-8">
                <IllustrationBox
                  number={item.number}
                  image={item.image}
                  title={item.title['en']}
                  text={item.text['en']}
                  className="text-3xl"
                />
              </div>
            </div>
          ))
        }
      </div>

      <FlickitySlider className="mb-8 md:mb-12">
        {
          CollegeAchievements.listItems.map((item, i) => (
            <div key={i} className="w-full md:w-1/2 p-4">
              <Testimonial
                title={item.title['en']}
                color={item.color}
              >
                {
                  item.content['en'].map((text, j) => (
                    <p key={j} className="mb-4">
                      { text }
                    </p>
                  ))
                }
              </Testimonial>
            </div>
          ))
        }
      </FlickitySlider>
    </div>

    <div className="bg-gray-200 py-8 md:py-12 md:pb-24" id="efficient-management">
      <div className="container">
        <h2 className="text-3xl md:text-5xl text-blue-500 text-center mb-2" data-aos="fade-down">Efficient Management</h2>
        <div className="text-center mx-auto max-w-xl text-sm md:text-base mb-8 md:mb-12 font-normal" data-aos="fade-up">
          Effectiveness and Efficiency in decision-making is core to IFT’s management. Our experienced management team ensures the Institute’s effective operation and successful completion of its mission.
        </div>

        <FlickitySlider>
          {
            TeamMembers.map((member, i) => (
              <div key={i} className="w-full md:w-1/4 mb-12 text-center">
                <div className="flex flex-col items-center mx-4">
                  <img src={`/AnnualReport2017-2018${member.image}`} alt="member" className="rounded-full w-40 h-40 mb-2" />

                  <div className="w-full text-2xl text-blue-500">
                    { member.name['en'] }
                  </div>
                  <div className="w-2/3 mb-2">
                    { member.title['en'] }
                  </div>
                  <MoreText limitTextLength={member.textLength || 450} className="w-full text-sm font-normal">
                    { member.description['en'] }
                  </MoreText>
                </div>
              </div>
            ))
          }
        </FlickitySlider>
      </div>
    </div>

    <div className="container py-8 md:py-12 md:pb-24" id="honours-and-awards">
      <h2 className="text-3xl md:text-5xl text-yellow-500 text-center mb-2" data-aos="fade-down">Honours and Awards</h2>
      <div className="text-center mx-auto max-w-4xl text-sm md:text-base mb-8 md:mb-12 font-normal" data-aos="fade-up">
        As a tourism education institute striving for excellence,  IFT has received great compliments for its teaching quality and contributions to the community. The Institute has been awarded with honours and awards bestowed by bodies in Macao SAR, Mainland China and across the world. Below are some of them:
      </div>

      <FlickitySlider>
        {
          Awards.map((award, i) => (
            <div key={i} className="w-1/2 md:w-1/4 mb-12 text-center">
              <div className="mx-8">
                <div className="mx-auto rounded-full bg-gray-200 w-32 h-32 flex items-center justify-center mb-4">
                  <img src={`/AnnualReport2017-2018${award.image}`} className="w-24 h-24" alt="" />
                </div>
                <div className="text-center">
                  { award.content['en'].map((text, j) => {
                      return (
                        <p key={j} className={`mb-1 ${(j === 0 ? 'text-yellow-500' : 'text-gray-700 text-sm')}`}>{ text }</p>
                      )
                    })
                  }
                </div>
              </div>
            </div>
          ))
        }
      </FlickitySlider>
    </div>

    <div className="bg-gray-200 py-8 md:py-12" data-aos="fade-up">
      <div className="container">
        {
          <FinancialReportAndPersonnelStructure
            langKey={props.pageContext.langKey}
            description1="IFT again maintained a sound financial position in the 2017 financial year, reflecting the prudence of its management."
            description2="IFT persisted in its efforts to attract and retain high-quality staff in academic year 2017/18. The number of full-time academic staff remain similar to last academic year. The tally of staff, academic and otherwise, rose by 1.76%."
          />
        }
      </div>
    </div>

    <div className="container py-8 md:py-12 md:pb-24" id="year-in-review">
      <h2 className="text-3xl md:text-5xl text-blue-500 text-center mb-8 md:mb-12" data-aos="fade-down">Year in Review</h2>

      <AnnualReviewSlider langKey={props.pageContext.langKey} />
    </div>

    <div className="bg-gray-200 py-8 md:py-12 md:pb-24" id="student-activities">
      <div className="container">
        <h2 className="text-3xl md:text-5xl text-orange-500 text-center mb-8 md:mb-12" data-aos="fade-down">Student Activities</h2>

        <FlickitySlider>
          {
            StudentActivities.map((activity, i) => (
              <div key={i} className="w-full md:w-1/2 p-4">
                <Testimonial
                  title={activity.title['en']}
                  color={i%2===0 ? 'blue' : 'orange'}
                >
                  {
                    activity.content['en'].map((text, j) => (
                      <p key={j} className="mb-4" dangerouslySetInnerHTML={{ __html: text }}></p>
                    ))
                  }
                  { (activity.video && activity.video['en']) ? <p><VideoButton url={activity.video['en']} /></p> : null }
                </Testimonial>
              </div>
            ))
          }
        </FlickitySlider>
      </div>
    </div>

    <div className="container py-8 md:py-12 md:pb-24">
      <h2 className="text-3xl md:text-5xl text-blue-500 text-center mb-8 md:mb-12" data-aos="fade-down">Student Stories</h2>

      <FlickitySlider>
        {
          StudentStories.map((story, i) => (
            <div key={i} className="w-full flex flex-row">
              <div className="w-full mx-4">
                <div className="text-lg mb-4">{ story.title['en'] }</div>
                <div className="font-normal text-justify">
                  {
                    story.content['en'].map((text, j) => (
                      <p key={j} className="mb-4" dangerouslySetInnerHTML={{ __html: text }}></p>
                    ))
                  }
                { (story.video && story.video['en']) ? <p><VideoButton url={story.video['en']} /></p> : null }
                </div>
              </div>
            </div>
          ))
        }
      </FlickitySlider>
    </div>
  </Layout>
)

export default IndexPage
